import * as Yup from 'yup'

import required from '@galo-monitor/forms/validators/required.validator'

const modelSchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  machine_type_id: required({ t })(Yup.string()),
  machine_maker_name: required({ t })(Yup.string())
})

export default modelSchema
